import React from 'react';
import DashboardRoute from "./dashboard/Dashboard.Route"
import AssetMasterRoute from './master/Master.Route';
import AssetRoute from './asset/Asset.Route';
import MaintenanceRoute from './maintenance/Maintenance.Route';
import ReportRoute from './reports_analytics/Report.Route';
import SuperAdminRoute from './superAdmin/SuperAdmin.Route';
import SettingsRoute from './settings/SettingsRoute';
import UserManagementRoute from './user_management/UserManagementRoute';
import CustomerFreelancerLinkRoute from './customer_freelancer_link/CustomerFreelancerLinkRoute';

const PrivateRoute = () => {
    return [
        ...DashboardRoute(),
        ...AssetMasterRoute(),
        ...AssetRoute(),
        ...MaintenanceRoute(),
        ...ReportRoute(),
        ...SuperAdminRoute(),
        ...SettingsRoute(),
        ...UserManagementRoute(),
        ...CustomerFreelancerLinkRoute(),
    ]
}

export default PrivateRoute